export const deviceTemplates = {
  SmartPi: {name: "SmartPi"},
  RpiGPIO: {name: "Lastabwurf_EW", direction: "in", gpio: 23},
  ModbusRTUMeter: {deviceType: "PRO380-Mod", name: "", modbusId: 1, usbDevice: "/dev/ttyUSB0"},
  ModbusTCPMeter: {deviceType: "EMUProII", name: "", modbusId: 1, ip: ""},
  ModbusMeter: {deviceType: "ModbusMeter", name: "", modbusId: 1, templateId: "", ip: "", port: 502, usbDevice: "/dev/ttyUSB0", baudRate: 9600, parity: "even"},
  DSMR5: {name: "SAK Smart Meter", usbDevice: "/dev/ttyUSB0"},
  ShellyPro3EM: {name: "Shelly Pro 3EM", apiUrl: "https://", authKey: "", id: ""},
  SGrDevice: {name: "", xmlName: "Choose an XML file", xmlUrl: "", xmlRef: "", category: "", configurationValues: []},
  DlmsCosem: {name: "", serialPort: "/dev/ttyUSB0", baudRate: 38400, meterAddress: 1, encryptionKey: "", authenticationKey: "", extendedData: false},
};

export const sccjsonTemplate = {
  "circuits": [],
  "devices": {
    "RpiGPIO": [{"name": "Lastabwurf_EW", "direction": "in", "gpio": 23}],
    "SmartPi": {"name": "SmartPi"},
  },
};

export const circuitTemplate = {
  measurement: {type: 'device', deviceName: ''},
  controlSettings: {decissionInterval: 60, lowerLimit: 80, upperLimit: 100},
  actions: [],
  evChargers: [],
  circuitName: '',
};

